<birdz-auth>
  <!-- header -->
  <birdz-layout *ifAuthorized>
    <birdz-header
      layout-header
      [title]="(appName$ | async) ?? ''"
      [icon]="(appIcon$ | async) ?? ''"
      [isLoading]="(isLoading$ | async) ?? false"
      [profile]="(profile$ | async) ?? undefined"
      [logoRedirectionUrl]="logoRedirectionUrl"
    >
      <ng-content header-navigation>
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        <nav birdzTabListScroll mat-tab-nav-bar [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
          @for (tab of tabs; track tab.path) {
            @if (!tab.developerOnly || isDev()) {
              @if (tab.path === 'query') {
                <a
                  mat-tab-link
                  [routerLink]="isOnQueryRoute() ? tab.path : null"
                  routerLinkActive
                  #rla="routerLinkActive"
                  class="bdz-tab"
                  [active]="rla.isActive"
                  [disabled]="!isOnQueryRoute()"
                >
                  <mat-icon>{{ tab.icon }}</mat-icon>
                  <span>{{ tab.label | transloco }}</span>
                </a>
              } @else {
                <a
                  mat-tab-link
                  [routerLink]="tab.path"
                  queryParamsHandling="merge"
                  routerLinkActive
                  #rla="routerLinkActive"
                  [class.bdz-tab--developer]="tab.developerOnly"
                  class="bdz-tab"
                  [active]="rla.isActive"
                >
                  <mat-icon>{{ tab.icon }}</mat-icon>
                  <span>{{ tab.label | transloco }}</span>
                </a>
              }
            }
          }
        </nav>
      </ng-content>
    </birdz-header>

    <!-- sidebar -->
    <birdz-sidebar
      layout-sidebar
      [profile]="(profile$ | async) ?? undefined"
      [userSettings]="(settings$ | async) ?? {}"
      (userSettingsChange)="onUserSettingsChange($event)"
      [contactCallback]="contactCallback"
      (avatarFileChange)="onAvatarFileChanged($event)"
      (logout)="logout()"
    />

    <birdz-drawer layout-left [closed]="isOnQueryRoute()">
      <app-filter class="birdz-filter-container"></app-filter>
    </birdz-drawer>

    <ng-container layout-main>
      <div class="content">
        @if (needsTenant$ | async) {
          <birdz-card-tenant></birdz-card-tenant>
        } @else {
          <router-outlet></router-outlet>
        }
      </div>
    </ng-container>
  </birdz-layout>
</birdz-auth>
